import { Layout } from 'components';
import { Outlet } from 'libs/navigation';
import { AccountLayoutOverrideStyles } from 'modules/account/AccountLayoutOverrideStyles';

import { GlobalStyled } from './GlobalStyles';
import { NavigationMiddleware } from './NavigationMiddleware';

export const Main = () => (
  <NavigationMiddleware>
    {({ isLoginPage, isAccountPages }) => {
      if (isLoginPage) {
        return (
          <>
            {GlobalStyled}
            <Outlet />
          </>
        );
      }
      return (
        <Layout>
          {GlobalStyled}
          {isAccountPages && <AccountLayoutOverrideStyles />}
          <Outlet />
        </Layout>
      );
    }}
  </NavigationMiddleware>
);
